let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("awkVi")).then(() => parcelRequire('iEu8X'));